import { LotFilterInterface } from '@store/types'

import { DEFAULT_ANY_OPTION } from '../constants'

const FILTER_INITIAL_STATE_HOUSE_AND_LAND: LotFilterInterface = {
  configurations: {
    bed: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    study: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    bath: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    powderRoom: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    car: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
  },
  builder: [],
  storey: [],
  packages: [],
  lotConfiguration: {
    frontage: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    area: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    price: { min: DEFAULT_ANY_OPTION, max: DEFAULT_ANY_OPTION },
    aspects: [],
    propertyTypes: [],
  },
  showOnlyAvailable: false,
  anyStage: true,
  apply: false,
}

export default FILTER_INITIAL_STATE_HOUSE_AND_LAND
